function messageBox(error) {
      let title, titleText, content, contentText, button, buttonText
      let pushType = 1; 
      if (error) {
            titleText = '系统通知';
            contentText = '系统正在升级中  请稍后访问';
            buttonText = '知道了'
      } else {
            if (!localStorage.getItem('setTempConfigs')) return
            if (!JSON.parse(localStorage.getItem('setTempConfigs')).noticeMessage) return
            if (JSON.parse(localStorage.getItem('setTempConfigs')).noticeMessage.length === 0) return
            title = JSON.parse(localStorage.getItem('setTempConfigs')).noticeMessage[0].noticeTitle;
            pushType = JSON.parse(localStorage.getItem('setTempConfigs')).noticeMessage[0].pushType;
            if (title.length <= 40) {
                  titleText = title
            } else {
                  titleText = title.substr(1, 40)
            }
            content = JSON.parse(localStorage.getItem('setTempConfigs')).noticeMessage[0].noticeContent
            if (content.length <= 240) {
                  contentText = content
            } else {
                  contentText = content.substr(1, 40)
            }
            button = JSON.parse(localStorage.getItem('setTempConfigs')).noticeMessage[0].buttonText
            if (button.length <= 6) {
                  buttonText = button
            } else {
                  buttonText = button.substr(1, 6)
            }
      }
      let template = `
            <div id="messageBox">
            <svg t="1635939799443" class="delet-icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="3161" width="20" height="20"><path d="M512 0C229.29408 0 0 229.248 0 512c0 282.76736 229.26336 512 512 512 282.76736 0 512-229.18144 512-512C1024 229.29408 794.76736 0 512 0z m209.90976 654.09024a47.5904 47.5904 0 0 1 14.08512 33.90976 47.95392 47.95392 0 0 1-47.99488 47.99488 47.75936 47.75936 0 0 1-33.90976-14.08512L512 579.89632l-141.99296 142.05952a47.9488 47.9488 0 0 1-34.00704 14.08512c-26.45504 0-47.95904-21.45792-47.95904-48.01536A47.68768 47.68768 0 0 1 302.08 654.15168L444.15488 512 302.1056 369.95584a47.88224 47.88224 0 0 1-14.03904-33.95584 47.99488 47.99488 0 0 1 81.92-33.95584l141.99296 142.07488L654.07488 302.08a47.92832 47.92832 0 0 1 33.90976-14.03904c26.48576 0 47.99488 21.45792 47.99488 47.99488a47.75424 47.75424 0 0 1-14.08512 33.95584l-141.99808 141.99296 142.01344 142.1056z m0 0" fill="#dddddd" p-id="3162"></path></svg>
                  <h3><svg t="1636080872888" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="2459" width="20" height="20" style="display:block; float:left;margin-right:8px;"><path d="M512.74 57C266.71 57 67.26 256.44 67.26 502.48c0 246.03 199.45 445.48 445.48 445.48s445.48-199.45 445.48-445.48C958.22 256.44 758.77 57 512.74 57z m127.98 693.31c0 10.47-5.4 20.18-14.31 25.7a30.227 30.227 0 0 1-15.9 4.51c-4.6 0-9.21-1.06-13.45-3.16L367.33 662.98c-14.96-7.44-21.04-25.58-13.6-40.51 7.44-14.93 25.67-21.01 40.51-13.6l186.06 92.65V301.66l-196.94 89.9c-3.92 1.77-8.2 2.71-12.54 2.71H270.08v199.84h21.18c16.7 0 30.21 13.51 30.21 30.21s-13.51 30.21-30.21 30.21h-51.4c-16.7 0-30.21-13.51-30.21-30.21V364.06c0-16.7 13.51-30.21 30.21-30.21h124.36l233.74-106.69a30.445 30.445 0 0 1 28.89 2.09 30.216 30.216 0 0 1 13.87 25.4v495.66z m110.99-89.64c-5.96 6.9-14.37 10.44-22.84 10.44-7.02 0-14.04-2.42-19.77-7.38-12.63-10.92-13.99-29.98-3.07-42.6 107.43-124.16 5.52-233.15 1.12-237.72-11.51-12.01-11.21-31.13 0.77-42.69 11.98-11.54 31.01-11.27 42.58 0.59 50.87 52.17 116.58 186.06 1.21 319.36z" p-id="2460" fill="#FF5454"></path></svg>${titleText}</h3>
                  <p>${contentText}</p>
                  <button id="buttonText">${buttonText}</button>
             </div>
             <style>
                  #messageBox .delet-icon{
                        float:right;
                        cursor: pointer;
                  }
                  #messageBox{
                        padding: 16px 24px;
                        width: 400px;
                        background: #FFFFFF;
                        box-shadow: 0px 0px 8px 4px rgba(0, 0, 0, 0.05);
                        border-radius: 8px;
                        position: fixed;
                        right:24px;
                        top:104px;
                        z-index:2021;
                  }
                  #messageBox h3{
                        font-size: 16px;
                        font-family: PingFangSC-Semibold, PingFang SC;
                        font-weight: 600;
                        color: #333333;
                        line-height: 22px;
                  }
                  #messageBox p{
                        font-size: 14px;
                        font-family: PingFangSC-Regular, PingFang SC;
                        font-weight: 400;
                        color: #666666;
                        line-height: 24px;
                  }
                  #messageBox button{
                        color:#fff;
                        height: 32px;
                        border:none;
                        padding:0px 23px;
                        background: #1972FF;
                        box-shadow: 0px 0px 8px 4px rgba(0, 0, 0, 0.05);
                        border-radius: 5px;
                        float:right;
                        cursor: pointer;
                  }
             </style>          
             `
      let imgsrc = require('./src/assets/systembc.png');
      console.log('imgsrc---->',imgsrc)
      function getClientHeight()
      {
        var clientHeight=0;
        if(document.body.clientHeight&&document.documentElement.clientHeight)
        {
        var clientHeight = (document.body.clientHeight<document.documentElement.clientHeight)?document.body.clientHeight:document.documentElement.clientHeight;
        }
        else
        {
        var clientHeight = (document.body.clientHeight>document.documentElement.clientHeight)?document.body.clientHeight:document.documentElement.clientHeight;
        }
        return clientHeight;
      }
      let templateCover = 
      `
            <div id="message-cover">
                  <h3>${titleText}</h3>
                  <p>${contentText}</p>
            </div>
            <style>
            #message-cover{
                  padding-top:80px;
                  width:100%;
                  background: #fff url(${imgsrc}) no-repeat center 240px;
                  background-size: 1920px auto;
                  position: fixed;
                  left:0px;
                  top:0px;
                  z-index:20211117;
                  height: calc(100vh);
                  box-sizing: border-box;
            } 
            #message-cover h3{
                  margin:0px;
                  margin-bottom:8px;
                  text-align:center;
                  font-size: 48px;
                  font-family: PingFangSC-Semibold, PingFang SC;
                  font-weight: 600;
                  color: #08224D;
                  line-height: 80px;     
            } 
            #message-cover p{
                  margin:0px;
                  margin-bottom:40px;
                  text-align:center;
                  font-size: 18px;
                  font-family: PingFangSC-Regular, PingFang SC;
                  color: #08224D;
                  line-height: 28px;
            }   
            </style>
      `
      let tamplateType = pushType == 1 ? template : templateCover;
      document.querySelector('body').insertAdjacentHTML("beforebegin", tamplateType);

      if(pushType == 1){
            document.querySelector('.delet-icon').onclick = () => {
                  document.querySelector('#messageBox').remove();
                  sessionStorage.setItem("nomessage", false)
            };
            document.querySelector('#buttonText').onclick = () => {
                  document.querySelector('#messageBox').remove();
                  sessionStorage.setItem("nomessage", false)
            }
      }

}
export default messageBox